import React from 'react'
import {Modal} from "@material-ui/core";


export const BlackListModal = ({showModal = false}) => (
    <Modal
        open={showModal ? showModal : false}
        className="auth-modal-window blackist-user-modal"
    >
        <div className="auth-modal-body">
            <div className="logo">
                <img alt="logo-booking"
                     src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking_small.png'}/>
            </div>
            <div className="title-block">Ваш аккаунт в чёрном списке</div>
            <div className="write-email-claim">Свяжитесь с TONESKY для решения<br/>вопроса <a
                href="mailto:support@tonesky.ru">support@tonesky.ru</a></div>
        </div>
    </Modal>
)
